<template>
  <div class="youth-player-list">
    <div v-if="playerList.length" class="grid-list">
      <div v-for="(item, index) in playerList" :key="index" class="item">
        <img :src="item.player_img" alt="">
        <ul>
          <li class="name">{{item.k_name}}</li>
          <li>
            <p>NO.{{item.player_no}} / <span>{{ item.position }}</span></p>
            <p class="eng-name">{{item.e_name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="empty-div">
      <PageComingSoon />
    </div>
  </div>
</template>

<script>

import PageComingSoon from '@/components/Common/PageComingSoon.vue';

export default {
  name: 'YouthPlayerList',
  components: {PageComingSoon},
  props: ['routeName'],
  data() {
    return {
      playerList: [],
      thisyear: this.$store.state.year,
    }
  },
  watch: {
    routeName: {
      handler: function () {
        this.getPlayerList()
      }
    }
  },
  mounted () {
    this.getPlayerList()
  },
  methods: {
    async getPlayerList() {
      const youthAge = this.routeName.split('U')[this.routeName.split('U').length - 1];
      const {data} = await this.$http.get(`/player/youth?youth_age=${youthAge}&year=${this.thisyear}`);
      if(data.success) {
        this.playerList = data.data;
        this.playerList.map(item => {
          item.player_img = 'https://www.dragons.co.kr/' + item.player_img;
        })
      }
    }
  }
}
</script>
